<div class="flex flex-row gap-1 rounded shadow">
    <div class="p-2 w-[2ch] rounded-l shadow" [style.background]="getSummaryColor()">

    </div>
    <div class="grow p-2">{{ taskName }}</div>
    <div class="p-2 w-[20ch]">{{ lastRun }}</div>
    <div class="p-2 w-[10ch] flex flex-row gap-1 items-center">
        @if (taskSummary?.recent) {
            @for (recentRun of taskSummary?.recent ; track recentRun.id) {
                <div class="w-2 h-2 shadow-sm rounded-sm" [style.background]="getRunColor(recentRun)" title="{{ recentRun.start }}">

                </div>
            }
        }
    </div>
</div>